import script from "./hpImpressum.vue?vue&type=script&setup=true&lang=js"
export * from "./hpImpressum.vue?vue&type=script&setup=true&lang=js"

import "./hpImpressum.vue?vue&type=style&index=0&id=443e5c14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-443e5c14"]])

export default __exports__